<script setup lang="ts">
  import { IconClose, Text } from '@ui-kit';
</script>

<template>
  <span class="scan-screen-error" data-testid="scan-screen-error">
    <IconClose style="width: 32px; height: 32px;" />
  </span>
  <Text font="body-regular-12" color="error">
    {{ $t('Ошибка, попробуйте еще раз') }}
  </Text>
</template>

<style scoped>
  .scan-screen-error {
    display: flex;
    border-radius: 100%;
    border: 2px solid var(--sf-base-icon-error);
    padding: 4px;
  }

  .scan-screen-error svg {
    stroke: var(--sf-base-icon-error);
  }
</style>

